/** ハイクの所要時間（docs/03_simulation.md 6 章）。能力値・天候・スタミナの補正は P1 で加える */
import { BIOME_HIKE_SPEED, HIKE_BASE_FACTOR, hikeGradeFactor } from '../../config/balance';
import { hikeSpeedMs } from '../../core/hiking';
import type { EdgeData } from '../../core/world';

export interface HikeModifiers {
  /** 上り（grade > 0.05）の速度倍率 */
  uphill: number;
  /** 平地・下りの速度倍率 */
  flatDown: number;
  /** 天候・スタミナなど全体に掛かる倍率 */
  overall: number;
}

export const STANDARD_HIKE: HikeModifiers = { uphill: 1, flatDown: 1, overall: 1 };

export function segmentSpeedMs(grade: number, biome: number, mods: HikeModifiers): number {
  const biomeFactor = BIOME_HIKE_SPEED[biome] ?? 0;
  if (biomeFactor <= 0) return 0;
  const statFactor = grade > 0.05 ? mods.uphill : mods.flatDown;
  return hikeSpeedMs(
    grade,
    HIKE_BASE_FACTOR * hikeGradeFactor(grade) * biomeFactor * statFactor * mods.overall,
  );
}

/** 経路を歩く所要時間（秒）。forward=false は b → a */
export function edgeTimeS(edge: Pick<EdgeData, 'segments'>, forward: boolean, mods: HikeModifiers): number {
  let t = 0;
  for (const s of edge.segments) {
    const v = segmentSpeedMs(forward ? s.grade : -s.grade, s.biome, mods);
    if (v <= 0) return Infinity;
    t += s.lengthM / v;
  }
  return t;
}
